import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { initialAsyncReduxState } from '../../constants';
import { DevelopmentPlanNote } from '../../models/DevelopmentPlanNote/DevelopmentPlanNote';
import { AsyncReduxState } from '../../types';

export type DevelopmentPlanPrivateNotesState = AsyncReduxState<{
    isUpdating: boolean;
    notes: DevelopmentPlanNote[];
}>;

const initialState: DevelopmentPlanPrivateNotesState = {
    ...initialAsyncReduxState,
    isUpdating: false,
    notes: [],
};

export const developmentPlanPrivateNotesSlice = createSlice({
    name: 'developmentPlanPrivateNotesReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): DevelopmentPlanPrivateNotesState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setIsUpdating(state, action: PayloadAction<boolean>): DevelopmentPlanPrivateNotesState {
            return {
                ...state,
                isUpdating: action.payload,
            };
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): DevelopmentPlanPrivateNotesState {
            return {
                ...state,
                isSuccessful: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): DevelopmentPlanPrivateNotesState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setDevelopmentPlanPrivateNotes(state, action: PayloadAction<DevelopmentPlanNote[]>): DevelopmentPlanPrivateNotesState {
            return {
                ...state,
                notes: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setIsUpdating,
    setIsSuccessful,
    setError,
    setDevelopmentPlanPrivateNotes,
} = developmentPlanPrivateNotesSlice.actions;

export default developmentPlanPrivateNotesSlice.reducer;
